module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "货品汇总-机构"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    attrs: {
      "id": "common-scroll"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "goods-company-summary-base"
  }, [_c('div', {
    staticClass: "goods-company-summary-left"
  }, [_c('div', [_c('i', {
    staticClass: "goods-company-ico"
  }), _c('strong', {
    staticClass: "goods-company-name"
  }, [_vm._v(_vm._s(_vm.restaurant_name))]), _vm._v(" "), (_vm.bill_state === '10') ? _c('span', {
    staticClass: "goods-company-status"
  }, [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '11') ? _c('span', {
    staticClass: "goods-company-status"
  }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '12') ? _c('span', {
    staticClass: "goods-company-status"
  }, [_vm._v("已发货")]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '13') ? _c('span', {
    staticClass: "goods-company-status"
  }, [_vm._v("已收货")]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '14') ? _c('span', {
    staticClass: "goods-company-status"
  }, [_vm._v("已收货 已确认")]) : _vm._e()]), _vm._v(" "), _c('strong', {
    staticClass: "goods-company-detail-name"
  }, [_vm._v(_vm._s(_vm.goods_name))]), _vm._v(" "), _c('div', {
    staticClass: "lightblack-font"
  }, [(_vm.queryData.sort_method === '0' && _vm.queryData.bill_state !== 20 && _vm.queryData.bill_state !== 21) ? _c('span', [_vm._v("订货日期：")]) : _vm._e(), _vm._v(" "), (_vm.queryData.sort_method === '0' && (_vm.queryData.bill_state === 20 || _vm.queryData.bill_state === 21)) ? _c('span', [_vm._v("退货日期：")]) : _vm._e(), _vm._v(" "), (_vm.queryData.sort_method === '1') ? _c('span', [_vm._v("到货日期：")]) : _vm._e(), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.start_date) + " 至 " + _vm._s(_vm.end_date) + "\r\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-float"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-company-summary-wrapper"
  }, _vm._l((_vm.billCounts), function(billCount) {
    return _c('router-link', {
      staticClass: "goods-company-detail-list",
      attrs: {
        "to": {
          path: billCount.bill_state !== 20 && billCount.bill_state !== 21 ? '/all-order-bill' : 'all-return-bill',
          query: {
            bill_state: _vm.queryData.bill_state,
            end_date: _vm.queryData.end_date,
            start_date: _vm.queryData.start_date,
            filterShow: false,
            sort_method: billCount.bill_state !== 20 && billCount.bill_state !== 21 ? '1' : '2',
            organ_id: _vm.queryData.organ_id,
            restaurant_id: _vm.queryData.restaurant_id,
            goods_id: _vm.queryData.goods_id,
            goods_unit: _vm.queryData.goods_unit
          }
        }
      }
    }, [(billCount.bill_state === 20 || billCount.bill_state === 21) ? _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v("退货企业：" + _vm._s(_vm.queryData.restaurant_name))]) : _vm._e(), _vm._v(" "), (billCount.bill_state !== 20 && billCount.bill_state !== 21) ? _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v("订货：" + _vm._s(billCount.from_organ_name))]) : _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v("退货机构：" + _vm._s(billCount.from_organ_name))]), _vm._v(" "), (billCount.bill_state !== 20 && billCount.bill_state !== 21) ? _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v("送往：" + _vm._s(billCount.to_organ_name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "goods-company-detail-show"
    }, [_c('ul', {
      staticClass: "goods-company-detail-show-ul"
    }, [(billCount.bill_state === 20 || billCount.bill_state === 21) ? _c('li', [_vm._v("退：数量 " + _vm._s(billCount.goods_num))]) : _c('li', [_vm._v("订：数量 " + _vm._s(billCount.goods_num))]), _vm._v(" "), (billCount.bill_state !== 20 && billCount.bill_state !== 21) ? _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total))]) : _c('li', [_vm._v("退货金额：¥ " + _vm._s(billCount.sub_total))]), _vm._v(" "), (_vm.bill_state === '12' | _vm.bill_state === '13' | _vm.bill_state === '14') ? _c('li', [_vm._v("发：数量 " + _vm._s(billCount.goods_num_send))]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '12' | _vm.bill_state === '13' | _vm.bill_state === '14') ? _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total_send))]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '13' | _vm.bill_state === '14') ? _c('li', [_vm._v("收：数量 " + _vm._s(billCount.goods_num_recipient))]) : _vm._e(), _vm._v(" "), (_vm.bill_state === '13' | _vm.bill_state === '14') ? _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total_recipient))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "clear-float"
    })])
  }), 1)])]), _vm._v(" "), _c('get-total', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    ref: "cTotal",
    attrs: {
      "filter": _vm.filterData,
      "href": "/cldEdi/business/getOrganInfoReportTotal",
      "name": "餐企"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11245406!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GoodsOrganSummary.vue
// module id = 534
// module chunks = 1